import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  Button,
  Checkbox,
  VStack,
  HStack,
} from '@chakra-ui/react';
import React from 'react';

import { Typography } from 'packages/common-frontend/components/Typography';

export const ConfirmAcknowledgementModal = ({
  isOpen,
  updating,
  onClose,
  onConfirm,
}: {
  isOpen: boolean;
  updating: boolean;
  onClose: () => void;
  onConfirm: (latestOnly: boolean) => void;
}) => {
  const [latestOnly, setLatestOnly] = React.useState(false);
  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered>
      <ModalOverlay />
      <ModalContent padding="40px" maxWidth="600px">
        <ModalHeader>
          <Typography variant="section-title">
            Confirm Acknowledgement
          </Typography>
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <VStack spacing={4} align="stretch">
            <Typography variant="base-muted" colorScheme="gray">
              Are you sure you want to acknowledge selected receivable&apos;s
              data quality issue? This prompt won&apos;t appear again.
            </Typography>
            <Typography variant="base-muted" colorScheme="gray">
              Alternatively, the data tape may contain errors. Check the source
              data and upload a corrected version to resolve the issue instead.
            </Typography>
            <Checkbox
              isChecked={latestOnly}
              onChange={(e) => setLatestOnly(e.target.checked)}
            >
              <Typography variant="base-muted" colorScheme="gray">
                Acknowledge for latest reporting date only
              </Typography>
            </Checkbox>
          </VStack>
        </ModalBody>
        <ModalFooter>
          <HStack spacing={2} justifyContent="flex-end">
            <Button
              colorScheme="v2-aurora"
              variant="secondary"
              mr={3}
              onClick={onClose}
            >
              Cancel
            </Button>
            <Button
              colorScheme="v2-aurora"
              variant="primary"
              isActive
              onClick={() => {
                onConfirm(latestOnly);
              }}
              isLoading={updating}
            >
              Acknowledge
            </Button>
          </HStack>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
